import PermisoService from '../seguridad/service/permiso';
import CountryService from '../services/country';
import AuditService from './service/audit';
import CardService from './service/card';
import ClienteService from './service/cliente';
import ContactoService from './service/contacto';
import CotizacionService from './service/cotizacion';
import CotizadorService from './service/cotizador';
import CtacteService from './service/ctacte';
import EmailBlacklistService from './service/emailblacklist';
import EmailTemplateService from './service/emailtemplate';
import GatewayService from './service/gateway';
import MonedaService from './service/moneda';
import OperacionService from './service/operacion';
import OperacionComisionService from './service/operacioncomision';
import PaisService from './service/pais';
import PrestacionService from './service/prestacion';
import ProcesoCronService from './service/procesocron';
import ProductoService from './service/producto';
import ProductoTipoService from './service/productoTipo';
import PromocionService from './service/promocion';
import ProveedorService from './service/proveedor';
import RegionService from './service/region';
import RemitenteService from './service/remitente.service';
import SegmentoService from './service/segmento';
import SociedadService from './service/sociedad';
import UpgradeService from './service/upgrade';
import VoucherService from './service/voucher';
import RibbonService from './service/ribbon';
import VoucherTemplateService from './service/vouchertemplate';

export class EntityController {
  private url : string;
  constructor (url:string) {
    this.url = url;
  }
  
  private _audit : AuditService | undefined = undefined;
  audit = () => this._audit = (this._audit ?? new AuditService(this.url));
  
  private _card : CardService | undefined = undefined;
  card = () => this._card = (this._card ?? new CardService(this.url));
  
  private _cliente : ClienteService | undefined = undefined;
  cliente = () => this._cliente = (this._cliente ?? new ClienteService(this.url));
  
  private _cotizacion : CotizacionService | undefined = undefined;
  cotizacion = () => this._cotizacion = (this._cotizacion ?? new CotizacionService(this.url));
  
  private _cotizador : CotizadorService | undefined = undefined;
  cotizador = () => this._cotizador = (this._cotizador ?? new CotizadorService(this.url));
  
  private _country : CountryService | undefined = undefined;
  country = () => this._country = (this._country ?? new CountryService(this.url));
  
  private _ctacte : CtacteService | undefined = undefined;
  ctacte = () => this._ctacte = (this._ctacte ?? new CtacteService(this.url));
  
  private _emailblacklist : EmailBlacklistService | undefined = undefined;
  emailblacklist = () => this._emailblacklist = (this._emailblacklist ?? new EmailBlacklistService(this.url));
  
  private _emailtemplate : EmailTemplateService | undefined = undefined;
  emailtemplate = () => this._emailtemplate = (this._emailtemplate ?? new EmailTemplateService(this.url));
  
  private _vouchertemplate : VoucherTemplateService | undefined = undefined;
  vouchertemplate = () => this._vouchertemplate = (this._vouchertemplate ?? new VoucherTemplateService(this.url));
  
  private _gateway : GatewayService | undefined = undefined;
  gateway = () => this._gateway = (this._gateway ?? new GatewayService(this.url));
  
  private _moneda : MonedaService | undefined = undefined;
  moneda = () => this._moneda = (this._moneda ?? new MonedaService(this.url));
  
  private _operacion : OperacionService | undefined = undefined;
  operacion = () => this._operacion = (this._operacion ?? new OperacionService(this.url));
  
  private _region : RegionService | undefined = undefined;
  region = () => this._region = (this._region ?? new RegionService(this.url));
  
  private _voucher : VoucherService | undefined = undefined;
  voucher = () => this._voucher = (this._voucher ?? new VoucherService(this.url));

  private _contacto : ContactoService | undefined = undefined;
  contacto = () => this._contacto = (this._contacto ?? new ContactoService(this.url));

  private _pais : PaisService | undefined = undefined;
  pais = () => this._pais = (this._pais ?? new PaisService(this.url));

  private _permiso : PermisoService | undefined = undefined;
  permiso = () => this._permiso = (this._permiso ?? new PermisoService(this.url));

  private _operacioncomision : OperacionComisionService | undefined = undefined;
  operacioncomision = () => this._operacioncomision = (this._operacioncomision ?? new OperacionComisionService(this.url));

  private _proveedor : ProveedorService | undefined = undefined;
  proveedor = () => this._proveedor = (this._proveedor ?? new ProveedorService(this.url));

  private _producto : ProductoService | undefined = undefined;
  producto = () => this._producto = (this._producto ?? new ProductoService(this.url));

  private _productoTipo : ProductoTipoService | undefined = undefined;
  productoTipo = () => this._productoTipo = (this._productoTipo ?? new ProductoTipoService(this.url));

  private _promocion : PromocionService | undefined = undefined;
  promocion = () => this._promocion = (this._promocion ?? new PromocionService(this.url));

  private _segmento : SegmentoService | undefined = undefined;
  segmento = () => this._segmento = (this._segmento ?? new SegmentoService(this.url));

  private _sociedad : SociedadService | undefined = undefined;
  sociedad = () => this._sociedad = (this._sociedad ?? new SociedadService(this.url));

  private _prestacion : PrestacionService | undefined = undefined;
  prestacion = () => this._prestacion = (this._prestacion ?? new PrestacionService(this.url));
  
  private _procesoCron : ProcesoCronService | undefined = undefined;
  procesoCron = () => this._procesoCron = (this._procesoCron ?? new ProcesoCronService(this.url));
  
  private _upgrade : UpgradeService | undefined = undefined;
  upgrade = () => this._upgrade = (this._upgrade ?? new UpgradeService(this.url));
  
  private _remitente : RemitenteService | undefined = undefined;
  remitente = () => this._remitente = (this._remitente ?? new RemitenteService(this.url));
  
  private _ribbon : RibbonService | undefined = undefined;
  ribbon = () => this._ribbon = (this._ribbon ?? new RibbonService(this.url));
}